// Generated Price pending policy (NDR-D-038). Do not hand-edit.
(function(root,factory){
  const api=factory();
  if(typeof module==='object'&&module.exports) module.exports=api;
  else root.NoDrillBluewaterEstimatedPricing=api;
})(typeof globalThis!=='undefined'?globalThis:this,function(){
  'use strict';
  const profile=Object.freeze({id:'NDR-PRICE-PENDING-038',familyId:'NDR-V2-RL-SO-108',status:'price-pending',checkoutEnabled:false,optionPriceLabels:{control:{pull_chain:'Price pending',cordless:'Price pending',motorized:'Price pending'},chainMaterial:{plastic:'Price pending',stainless_steel:'Price pending'}}});
  function priceConfiguration(){return {valid:false,applicable:false,estimated:false,status:'price-pending',customerPrice:'Price pending',totalCents:null,checkoutEnabled:false,errors:[]};}
  return Object.freeze({profile,priceConfiguration});
});
